import {
  CreateProjectRequest,
  DeleteProjectRequest,
  Project,
  UpdateProjectRequest,
} from "@facade/contracts";

import { api } from "@facade/api";

export const projectsApi = {
  async get(options: { includeNotificationCounts?: boolean } = {}) {
    const { data } = await api.get<Project[]>("/projects", {
      params: {
        include_notification_counts: options.includeNotificationCounts,
      },
    });
    return data;
  },
  async getById(id: string) {
    const { data } = await api.get<Project>(`/projects/${id}`);
    return data;
  },
  async create(project: CreateProjectRequest) {
    const { data } = await api.post<Project>("/projects", project);
    return data;
  },
  async update(project: UpdateProjectRequest) {
    const { data } = await api.put<Project>(`/projects/${project.id}`, project);
    return data;
  },
  async delete(project: DeleteProjectRequest) {
    const { data } = await api.delete<Project>(`/projects/${project.id}`);
    return data;
  },
};
